export default __webpack_public_path__ + "static/media/2023-03-02T06_10_05.048Z_2_2.f62b0e8a.jpeg";